module.exports = __webpack_public_path__ + "static/media/13.a58f6b75.jpg";